import { Component, Input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Bill } from "src/app/shared/types/contract-types";
import { ContractService } from "src/app/shared/services/contract.service";

@Component({
  selector: "app-contract-details",
  templateUrl: "./contract-details.component.html",
  standalone: false,
})
export class ContractDetailsComponent {
  @Input() contractId: any;

  configId!: number | null;
  packageId!: number | null;
  customerId!: number | null;
  instanceId!: number | null;

  billsArray: Bill[] = [];

  constructor(
    public translate: TranslateService,
    private contractService: ContractService,
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    const getContractSubscription = this.contractService
      .getContractById(this.contractId)
      .subscribe((res) => {
        getContractSubscription.unsubscribe();
        this.customerId = res.id;
        this.configId = res.configId;
        this.instanceId = res.instanceId;
        this.packageId = res.packageId;
      });
  }
}
